import React, { useEffect, useState } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import toast from "react-hot-toast";
import { EditCMS } from "../actions/admin";

const EditCmsModal = ({ show, handleClose, record, getCMSData }) => {
  const [formValue, setFormValue] = useState({});

  useEffect(() => {
    if (record) {
      setFormValue(record);
    }
  }, [record]);

  // Generic change handler
  const handleChange = (section, field, value, cardIndex = null, subIndex = null) => {
    setFormValue(prev => {
      const updated = { ...prev };
      if (cardIndex !== null && subIndex !== null) {
        updated[section].cards[cardIndex].subDescription[subIndex] = value;
      } else if (cardIndex !== null) {
        updated[section].cards[cardIndex][field] = value;
      } else {
        updated[section][field] = value;
      }
      return updated;
    });
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        _id: record._id,
        ...formValue
      };

      const { status, message } = await EditCMS(payload);

      if (status === "success") {
        toast.success(message);
        getCMSData();
        handleClose();
      } else {
        toast.error(message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to update CMS");
    }
  };

  const renderCards = (section) => {
    return formValue[section]?.cards?.map((card, idx) => (
      <div key={idx} className="mb-3 border p-3 rounded">
        <h6>Card {idx + 1}</h6>
        <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

          <input
            type="text"
            className="rp_singleInput flex-grow-1 mb-1"
            placeholder="Title"
            value={card.title || ""}
            onChange={(e) => handleChange(section, "title", e.target.value, idx)}
          />
        </div>
        <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

          <input
            type="text"
            className="rp_singleInput flex-grow-1 mb-1"
            placeholder="Description"
            value={card.description || ""}
            onChange={(e) => handleChange(section, "description", e.target.value, idx)}
          />
        </div>
        {card.subDescription?.map((sub, sidx) => (
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              key={sidx}
              type="text"
              className="rp_singleInput flex-grow-1 mb-1"
              placeholder={`Sub Description ${sidx + 1}`}
              value={sub || ""}
              onChange={(e) => handleChange(section, null, e.target.value, idx, sidx)}
            />
          </div>
        ))}
      </div>
    ));
  };

  if (!formValue || !formValue.section1) return null;

  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      className="cmn_modal text-white">
      <Modal.Body>
        {/* <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>Edit CMS</h5>
          <button className="btn btn-light" onClick={handleClose}>X</button>
        </div> */}
        <div className="cmn_modal_header d-flex justify-content-between align-items-center">
          <p className="cmn_modal_title">Edit CMS</p>
          <button className="cmn_modal_closer rounded-5" onClick={handleClose}>
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        {/* Section 1 */}
        <div className="mb-3">
          <h6>Section 1</h6>
          <div className="rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">
            <input
              type="text"
              className="rp_singleInput flex-grow-1"
              placeholder="Description"
              value={formValue.section1.description || ""}
              onChange={(e) => handleChange("section1", "description", e.target.value)}
            />
          </div>
        </div>

        {/* Section 2 */}
        <div className="mb-3">
          <h6>Section 2</h6>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">
            <input
              type="text"
              className="rp_singleInput flex-grow-1"
              placeholder="Title"
              value={formValue.section2.title || ""}
              onChange={(e) => handleChange("section2", "title", e.target.value)}
            />
          </div>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">
            <input
              type="text"
              className="rp_singleInput flex-grow-1"
              placeholder="Description"
              value={formValue.section2.description || ""}
              onChange={(e) => handleChange("section2", "description", e.target.value)}
            />
          </div>
        </div>

        {/* Section 3 */}
        <div className="mb-3">
          <h6>Section 3</h6>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1 mb-1"
              placeholder="Title"
              value={formValue.section3.title || ""}
              onChange={(e) => handleChange("section3", "title", e.target.value)}
            />
          </div>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1 mb-1"
              placeholder="Description"
              value={formValue.section3.description || ""}
              onChange={(e) => handleChange("section3", "description", e.target.value)}
            />
          </div>
          {renderCards("section3")}
        </div>

        {/* Section 4 */}
        <div className="mb-3">
          <h6>Section 4</h6>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1 mb-1"
              placeholder="Title"
              value={formValue.section4.title || ""}
              onChange={(e) => handleChange("section4", "title", e.target.value)}
            />
          </div>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1"
              placeholder="Description"
              value={formValue.section4.description || ""}
              onChange={(e) => handleChange("section4", "description", e.target.value)}
            />
          </div>
        </div>

        {/* Section 5 */}
        <div className="mb-3">
          <h6>Section 5</h6>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1 mb-1"
              placeholder="Title"
              value={formValue.section5.title || ""}
              onChange={(e) => handleChange("section5", "title", e.target.value)}
            />
          </div>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1 mb-1"
              placeholder="Description"
              value={formValue.section5.description || ""}
              onChange={(e) => handleChange("section5", "description", e.target.value)}
            />
          </div>
          {renderCards("section5")}
        </div>

        {/* Section 6 */}
        <div className="mb-3">
          <h6>Section 6</h6>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1 mb-1"
              placeholder="Title"
              value={formValue.section6.title || ""}
              onChange={(e) => handleChange("section6", "title", e.target.value)}
            />
          </div>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1"
              placeholder="Description"
              value={formValue.section6.description || ""}
              onChange={(e) => handleChange("section6", "description", e.target.value)}
            />
          </div>
        </div>

        {/* Section 7 */}
        <div className="mb-3">
          <h6>Section 7</h6>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1 mb-1"
              placeholder="Title"
              value={formValue.section7.title || ""}
              onChange={(e) => handleChange("section7", "title", e.target.value)}
            />
          </div>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1 mb-1"
              placeholder="Description"
              value={formValue.section7.description || ""}
              onChange={(e) => handleChange("section7", "description", e.target.value)}
            />
          </div>
          {renderCards("section7")}
        </div>

        {/* Section 8 */}
        <div className="mb-3">
          <h6>Section 8</h6>
          <div className="mb-2 rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1"
              placeholder="Title"
              value={formValue.section8.title || ""}
              onChange={(e) => handleChange("section8", "title", e.target.value)}
            />
          </div>
          <div className="rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">

            <input
              type="text"
              className="rp_singleInput flex-grow-1"
              placeholder="Description"
              value={formValue.section8.description || ""}
              onChange={(e) => handleChange("section8", "description", e.target.value)}
            />
          </div>
        </div>

        <button className="orange_small_primary mt-3" onClick={handleSubmit}>
          Submit
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default EditCmsModal;
